module.exports = __webpack_public_path__ + "img/a449987a803e47a9aacbed43bce440c3a250d7a7 (1).1bbf5346.jpg";